import React from 'react'
import ReactDOM from 'react-dom/client'
import ReactGA from 'react-ga4'

import App from './app'
import reportWebVitals from './reportWebVitals'

ReactGA.initialize(process.env.REACT_APP_GA_KEY)
ReactGA.send({
  hitType: 'pageview',
  page: window.location.pathname,
})

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
